import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dropdown, Icon } from "semantic-ui-react";
import styles from "./ManagePatternButtons.module.css";
import { removePatternById } from "../../../../actions/patternActions";
import { Body2 } from "../../../../components/value-cssmodules/TextComponent";

const ManagePatternButtons: React.FC<any> = ({
  id,
  removePattern,
}) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleEdit = () => navigate(`/manage-pattern/${id}`);
  const handleRemove = () => setShowConfirm(true);

  return (
    <div className={styles.container}>
      <Dropdown
        icon={null}
        trigger={<Icon name="pencil alternate" size="large" className={styles.pencilIcon} />}
        pointing="top right"
        className="icon"
      >
        <Dropdown.Menu>
          <Dropdown.Item onClick={handleEdit} icon="edit" text={<FormattedMessage id="pattern.editPattern" defaultMessage="Edit pattern" />} />
          <Dropdown.Item onClick={handleRemove} icon="trash" text={<FormattedMessage id="pattern.removePattern" defaultMessage="Remove pattern" />} />
        </Dropdown.Menu>
      </Dropdown>
      {showConfirm && (
        <div className={styles.confirmBox}>
          <Body2>
            <FormattedMessage id="pattern.areYouSure" defaultMessage="Would you really like to remove this pattern?" />
          </Body2>
          <button
            type="button"
            className={styles.yesButton}
            onClick={() => { removePattern(id, navigate); setShowConfirm(false); }}
          >
            <FormattedMessage id="site.yes" defaultMessage="Yes" />
          </button>
          <button
            type="button"
            className={styles.noButton}
            onClick={() => setShowConfirm(false)}
          >
            <FormattedMessage id="site.no" defaultMessage="No" />
          </button>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  removePattern: (id: string, navigate: any) =>
    dispatch(removePatternById(id, navigate)),
});

export default connect(
  null,
  mapDispatchToProps
)(ManagePatternButtons);
